import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { GiftCard } from '@repo/ui/src/types/basket';
import {
  OrderLineItemData,
  BasketLineItemData,
  OptionLineItemData,
  LineItem,
} from '@repo/ui/src/types/lineItem';

export const isOptionItem = (
  lineItem: OrderLineItemData | OptionLineItemData,
): lineItem is OptionLineItemData => !!(lineItem as OptionLineItemData).optionId;
export const isBasketLineItem = (
  lineItem: OrderLineItemData | OptionLineItemData,
): lineItem is BasketLineItemData => !!(lineItem as BasketLineItemData).options;

export const isGiftCard = (item: LineItem | GiftCard): item is GiftCard =>
  !!(item as GiftCard).email;

const createLineItem = (
  data: OrderLineItemData | OptionLineItemData,
  position?: number,
): LineItem => {
  const isOptionLI = isOptionItem(data);
  const isBasketLI = isBasketLineItem(data);

  const productOptions = isBasketLI ? (data.options ?? []) : [];
  const warrantyOptions = productOptions?.find((option) => option.id === 'warranty')?.values ?? [];
  const warrantyExtendedOptions =
    warrantyOptions?.filter((option) => option.id !== 'DEFAULT') ?? [];
  const warrantyDefaultOption = warrantyOptions?.find((option) => option.id === 'DEFAULT');

  const optionItems = !isOptionLI
    ? (data.optionItems?.map((optionItem, i) => createLineItem(optionItem, i)) ?? [])
    : [];
  const attachedWarranty = optionItems?.find((option) => option.optionId === 'warranty');
  const isExtendedWarrantyAttached =
    !!attachedWarranty && attachedWarranty.optionValueId !== 'DEFAULT';

  const { optionId = null, optionValueId = null } = isOptionLI ? data : {};

  const hasDiscount = !!data.originalPrice && data.originalPrice > data.price;

  return {
    baseDiscount: 0,
    basePrice: 0,
    bonus: false,
    category: '',
    description: '',
    discount: 0,
    id: '',
    productUrl: '',
    tax: 0,
    ...data,
    isOptionLI,
    isBasketLI,
    optionItems,
    productOptions,
    warrantyOptions,
    warrantyExtendedOptions,
    warrantyDefaultOption,
    attachedWarranty,
    isExtendedWarrantyAttached,
    hasDiscount,
    optionId,
    optionValueId,
    position,
    getMainImageSize(width: number, aspectWidth: number, aspectHeight: number) {
      const url = data.image?.split('?')?.[0];
      return buildImageSrc(null, width, aspectWidth, aspectHeight, url);
    },
  };
};

export default createLineItem;
